// import { useState, useEffect } from "react";
import { DeviceType, Settings } from "../Types";
import Toggle from "../Components/toggle";
// import Slider from "../Components/slider";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useGlobalContext } from "../Context/GlobalContext";
import { useWindowSize } from "../Utils/Window";
import RSlider from "../Components/roundSlider";
import Pill from "../Components/pill";

const CobberSettings = (
    { settings, handleUpdateSettings, type }: 
    { settings: Settings, handleUpdateSettings: Function, type: DeviceType }
) => {

    const { showPopup } = useGlobalContext();
    const { width } = useWindowSize();

    // const [sensitivity, setSensitivity] = useState(1);

    // useEffect(() => {
    //     setSensitivity(type.sensitivities?.accel_range?.findIndex((r: number) => r === settings.accel_threshold) ?? 1);
    // }, [settings, type.sensitivities?.accel_range]);

    // const updateSensitivty = async (value: number) => {
    //     handleUpdateSettings({
    //         'accel_threshold': type.sensitivities?.accel_range[value], 
    //         'sleep_threshold': type.sensitivities?.accel_range[value]
    //     });
    // }

    const handleWakeClick = () => {
        showPopup({
            content: 
                <div className="accelerometer-info">
                    <InfoOutlinedIcon
                        className="top-left"
                        sx={{ cursor: "pointer" }}
                    />
                    <p>
                        WWHEN 'ENABLED' YOUR LIGHT WILL USE MOVEMENT DETECTION TO 
                        TURN ON AUTOMATICALLY (WITHIN 2-4 SECONDS).
                    </p>
                    <p>IT WILL ALSO TURN OFF AUTOMATICALLY AS PER YOUR TIME SETTINGS.</p>
                    <p>
                        NOTE, IF THE LIGHT IS TURNED OFF MANUALLY, IT WILL NOT AUTO WAKE.
                    </p>
                </div>,
            titleIcon: <InfoOutlinedIcon />,
            customClass: "button-small"
        });
    };

    // const handleSenseClick = () => {
    //     showPopup({
    //         content: 
    //             <div className="accelerometer-info">
    //                 <InfoOutlinedIcon
    //                     className="top-left"
    //                     sx={{ cursor: "pointer" }}
    //                 />
    //                 <p>WHEN BRAKING IS DETECTED,THE LIGHT MODE INTENSITY WILL SPIKE.</p>
    //                 <p>STANDARD: LIGHT INTENSITY SPIKES TO 100%.</p>
    //                 <p>PROGRESSIVE: LIGHT INTENSITY MATCHES HOW QUICKLY YOU'RE SLOWING DOWN.</p>
    //             </div>,
    //         titleIcon: <InfoOutlinedIcon />,
    //         customClass: "button-small"
    //     });
    // };

    return(
        <div className="cobber-settings" style={{ padding: "40px 20px" }}>
            <InfoOutlinedIcon
                className="top-right"
                sx={{ cursor: "pointer" }}
                onClick={() => handleWakeClick()}
            />
            <h2 style={{textAlign: 'center', marginBottom: '20px'}}>AUTO WAKE + SLEEP</h2>
            <Toggle
                rightLabel={width > 1550 ? "DISABLE" : ""}
                leftLabel={width > 1550 ? "ENABLE" : ""}
                value={settings.smartLighting}
                setValue={(value: boolean) => handleUpdateSettings({'smartLighting': value})}
                center={true}
            />
            <div style={{borderBottom: '1px solid #6FFBB0', paddingBottom: '30px'}}></div>
            { settings.smartLighting && <>
                <div style={{ margin: "30px" }}>
                    {/* <RSlider 
                        title="SET WAKE TIME"
                        value={settings?.min_time_before_wake} 
                        setValue={(value: number) => handleUpdateSettings({'min_time_before_wake': value})}
                        units="SECONDS"
                        min={2}
                        max={10}
                        step={1}
                    /> */}
                    <div className="wake-label">WAKES AUTOMATICALLY WITHIN 4 SECONDS</div>
                    {/* <Pill 
                        value={settings?.min_time_before_wake}
                        setValue={(value: number) => handleUpdateSettings({'min_time_before_wake': value})}
                        segments={[
                            {label: 'SHORT', value: 2},
                            {label: 'MEDIUM', value: 3},
                            {label: 'LONG', value: 4}
                        ]} 
                    /> */}
                </div>
                <div style={{ marginTop: "30px" }}>
                    <RSlider 
                        title="SET SLEEP TIME"
                        value={settings?.min_time_before_sleep} 
                        setValue={(value: number) => handleUpdateSettings({'min_time_before_sleep': value})}
                        units="SECONDS"
                        min={10}
                        max={300}
                        step={10}
                    />
                </div>
                {/* <div style={{display: 'flex', justifyContent: 'end'}}>
                    <InfoOutlinedIcon
                        sx={{ cursor: "pointer", marginRight: "-10px" }}
                        onClick={() => handleSenseClick()}
                    />
                </div> */}
                {/* <Slider
                    label={`${width > 1550 ? 'ADJUST' : ''} SENSITIVITY`}
                    rightLabel="HIGH"
                    leftLabel="LOW"
                    min={0}
                    max={type.sensitivities?.accel_range?.length - 1}
                    value={sensitivity}
                    setValue={(value: number) => setSensitivity(value)}
                    updateValue={(value: number) => updateSensitivty(value)}
                    step={1}
                /> */}
            </>}
        </div>
    );
}

export default CobberSettings;